import styled from 'styled-components';
import { palette } from 'styles/colors';

export const CallToActionSecondaryContainer = styled.div`
  padding: 80px 0;
`;

export const CTAChildrenContainer = styled.div`
  text-align: center;
  font-size: 22px;
  color: ${palette.footerBackground};
  font-weight: 300;

  a {
    color: ${palette.snowFlower};
    text-decoration: none;
  }
`;
